import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useLocation,
} from "react-router-dom";
import { connect } from "react-redux";
// import useMediaQuery from "use-media-antd-query";
import { getAPIUrl } from "./configs/global_var.js";

// import Home from "./view/Home/index.js";
import Publish from "./view/Publish/index.js";
import MyApplication from "./view/myApplication/index.js";
// import Setting from "./view/Setting/index.js";
import Contact from "./view/Contact/index.js";
import Register from "./components/register/index.js";
import Header from "./components/header/index";
// import logo from "./assets/img/logo/veera.png";
// import logoMobile from "./assets/img/logo/veera.png";

function Index(props) {
  const isLogin = props.isLogin;
  const isRegister = props.isRegister;
  return (
    <Router basename="/ecommerce">
      <Switch>
        <Route path="/:id" children={<Child isLogin={isLogin} />} />
        <Redirect to="/home" />
      </Switch>
      <Switch>
        <Route path="/home">
          <Publish isLogin={isLogin} />
        </Route>
        <Route path="/contact">
          <Contact isLogin={isLogin} />
        </Route>
        <Route path="/publish">
          <Publish isLogin={isLogin} />
        </Route>
        {/* <Route path="/setting">
          <Setting isLogin={isLogin} />
        </Route> */}
        <Route path="/my-application">
          <MyApplication isLogin={isLogin} />
        </Route>
        <Route path="/register">
          <Register isLogin={isRegister} />
        </Route>
      </Switch>
    </Router>
  );
}

function Child(props) {
  const location = useLocation();
  // const colSize = useMediaQuery();
  // const [mobileView, setMobileView] = useState(colSize);
  const [fetchLogo, setFetchLogo] = useState("");

  // useEffect(async () => {
  //   // setMobileView(colSize);
  //   const newLogo = await getAPIUrl();
  //   console.log(newLogo)
  //   setFetchLogo(newLogo[0].logo);
  // }, []);

  // useEffect(() => {
  // async function fetchData() {
  //   // You can await here
  //   const response = await MyAPI.getData(someId);
  //   // ...
  // }
  // fetchData();
// }, [someId]); 
// Or [] if effect doesn't need props or state

  useEffect(() => {
    async function fetchData() {
    // setMobileView(colSize);
    const newLogo = await getAPIUrl();
    setFetchLogo(newLogo[0].logo); 
    }
    fetchData()
  }, [])

  return (
    <Header
      content={location.pathname.substring(1) !== "register"}
      isLogin={props.isLogin}
      isRegister={props.isRegister}
      logo={fetchLogo}
      params={location.pathname.substring(1)}
    />
  );
}

const mapStateToProps = (state) => {
  return {
    isLogin: state.auth.login.isLogin,
    isRegister: state.auth.login.isRegister,
  };
};

export default connect(mapStateToProps, null)(Index);
